module.exports = __webpack_public_path__ + "static/media/uoa-19.ddfa5f88.jpg";